import * as React from 'react'

const Share: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width={25} height={25} fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.868 14.116a.75.75 0 0 0-.75-.75h-.583a.75.75 0 0 0-.75.75v8.298c0 .414.336.75.75.75h15.152c.203 0 .387-.08.523-.212a.748.748 0 0 0 .256-.565V14.09a.75.75 0 0 0-.75-.75h-.583a.75.75 0 0 0-.75.75v7.075H5.868v-7.048Z"
      fill="currentColor"
    />
    <path
      d="M11.39 2.124 5.905 7.388A1.02 1.02 0 0 0 7.319 8.86l3.765-3.615v9.115c0 .414.336.75.75.75h.584a.75.75 0 0 0 .75-.75V5.245l3.765 3.615a1.02 1.02 0 1 0 1.413-1.472l-5.484-5.264a1.073 1.073 0 0 0-1.473 0Z"
      fill="currentColor"
    />
  </svg>
)

export default Share
